import * as React from 'react';

import {CheckIcon, TimesIcon, EmailIcon, PhoneIcon, LinkedInIcon} from '../icon';

import styles from './contact-method-statuses.module.css';

type Props = {
    hasEmail?: boolean;
    hasPhone?: boolean;
    hasLinkedinUrl?: boolean;
};

export function ContactMethodStatuses(props: Props) {
    return (
        <div className={styles.container}>
            <div
                data-tooltip-place='top-end'
                data-tip={props.hasEmail ? 'Add to view email address' : 'No email address'}
                // @ts-expect-error
                className={!props.hasEmail && styles.missing}
            >
                {getStatusIcon(props.hasEmail)}
                <EmailIcon size={13} wrapWithDiv={false} />
            </div>
            <div
                data-tooltip-place='top-end'
                data-tip={props.hasPhone ? 'Add to view phone number' : 'No phone number'}
                // @ts-expect-error
                className={!props.hasPhone && styles.missing}
            >
                {getStatusIcon(props.hasPhone)}
                <PhoneIcon size={15} wrapWithDiv={false} />
            </div>
            <div
                data-tooltip-place='top-end'
                data-tip={
                    props.hasLinkedinUrl ? 'Add to view LinkedIn profile' : 'No LinkedIn profile'
                }
                // @ts-expect-error
                className={!props.hasLinkedinUrl && styles.missing}
            >
                {getStatusIcon(props.hasLinkedinUrl)}
                <LinkedInIcon size={15} wrapWithDiv={false} />
            </div>
        </div>
    );
}

const getStatusIcon = (hasMethod?: boolean | null) =>
    hasMethod ? (
        <CheckIcon size={11} wrapWithDiv={false} />
    ) : (
        <TimesIcon size={12} wrapWithDiv={false} />
    );
